// Toyo Party configuration
import { AppConfig } from './types';
import { partyTheme } from './themes';
import { PARTY_GAMES } from './games';

export const partyConfig: AppConfig = {
  // App identity
  appId: 'party',
  appName: 'Toyo Party',
  appTagline: 'Drink. Laugh. Play.',
  
  // Branding
  logo: '/assets/toyo-party-logo.png',
  homeUrl: 'https://toyo.games/party',
  
  // Theme
  theme: partyTheme,
  
  // Games - Party has fun drinking and social games
  games: PARTY_GAMES,
  
  // Feature flags
  features: {
    voting: true,
    hostPlaying: true,
    settings: true,
  },
  
  // Storage prefix
  storagePrefix: 'toyo-party',
  
  // SEO and metadata
  seo: {
    title: 'Toyo Party - Adult Party Games & Drinking Games | party.toyo.games',
    description: 'Fun adult party games and drinking games. Drinking Game, Hot Takes, Would You Rather, Are You Drunk, Rapid Fire, and more. Perfect for parties, social gatherings, and adult game nights. Play responsibly!',
    keywords: [
      'toyo party',
      'party games',
      'drinking games',
      'adult games',
      'hot takes',
      'would you rather',
      'are you drunk',
      'rapid fire',
      'stoned yet',
      'kinky or not',
      'play it loud',
      'party games for adults',
      'social games',
      'adult party games',
      'drinking game app',
      'party entertainment',
      'social drinking games',
      'adult trivia',
      'party activities',
    ],
    ogTitle: 'Toyo Party - Drink. Laugh. Play.',
    ogDescription: 'Fun adult party games and drinking games. Perfect for parties and social gatherings!',
    ogImage: '/assets/toyo-party-logo.png',
    ogUrl: 'https://party.toyo.games',
    twitterCard: 'summary_large_image',
    twitterTitle: 'Toyo Party - Drink. Laugh. Play.',
    twitterDescription: 'Fun adult party games and drinking games. Perfect for parties!',
    twitterImage: '/assets/toyo-party-logo.png',
  },
};

